import LoginPageComponent from '../../components/LoginPageComponent';

function LoginPage() {
  return <LoginPageComponent />;
}

export default LoginPage;
